module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('banet-modal-confirm', {
    attrs: {
      "show": _vm.showConfirm,
      "showFooter": true,
      "title": _vm.getTranslation('modal_confirm_title'),
      "body": _vm.getTranslation('label_confirm_user_delete')
    },
    on: {
      "confirmNo": function($event) {
        _vm.confirm(false)
      },
      "confirmYes": function($event) {
        _vm.confirm(true)
      }
    }
  }), _vm._v(" "), (!_vm.hideTitle) ? _c('h2', [_vm._v(_vm._s(_vm.getTranslation('lbl_userlist_headline')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-sm-4"
  }, [_c('form', {
    staticStyle: {
      "position": "relative",
      "z-index": "0"
    },
    attrs: {
      "id": "search"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon glyphicon glyphicon-search",
    attrs: {
      "aria-hidden": "true",
      "title": _vm.getTranslation('lbl_search')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "query",
      "placeholder": _vm.getTranslation('lbl_search')
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.searchQuery = ''
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-remove"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-sm-8"
  }, [_c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "to": "/history/user",
      "activeClass": "active",
      "tag": "button",
      "title": _vm.getTranslation('lbl_history_deleted')
    }
  }, [_c('i', {
    staticClass: "fa fa-history",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "to": ("/adduser/" + (_vm.isClientSubPage ? _vm.client._id : '')),
      "activeClass": "active",
      "tag": "button"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.getTranslation('app_lbl_action_user_create')))])], 1)])]), _vm._v(" "), _c('banet-tablegrid', {
    attrs: {
      "data": _vm.fullGridData,
      "columns": _vm.gridColumns,
      "filter-key": _vm.searchQuery,
      "actionCol": true,
      "editBtn": true,
      "deleteBtn": true,
      "actionLink": '/user',
      "history": '/history/user'
    },
    on: {
      "delete": _vm.userDelete
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-106386cd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/user/UserList.vue
// module id = 666
// module chunks = 0